var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5694 8.33842C17.7861 8.1321 18.0745 8.01803 18.3737 8.0203C18.673 8.02256 18.9596 8.14098 19.1732 8.35056C19.3867 8.56014 19.5105 8.84449 19.5184 9.14361C19.5264 9.44274 19.4178 9.73323 19.2156 9.95381L13.0771 17.6307C12.9715 17.7444 12.8441 17.8357 12.7025 17.899C12.5609 17.9623 12.408 17.9964 12.2529 17.9993C12.0978 18.0022 11.9437 17.9737 11.7998 17.9157C11.6559 17.8577 11.5252 17.7712 11.4156 17.6615L7.34478 13.5907C7.23142 13.4851 7.14049 13.3577 7.07743 13.2162C7.01436 13.0746 6.98045 12.9218 6.97772 12.7669C6.97499 12.612 7.00348 12.4581 7.06152 12.3144C7.11955 12.1708 7.20593 12.0402 7.31549 11.9307C7.42506 11.8211 7.55557 11.7347 7.69925 11.6767C7.84292 11.6187 7.99681 11.5902 8.15174 11.5929C8.30667 11.5956 8.45946 11.6295 8.601 11.6926C8.74253 11.7557 8.86992 11.8466 8.97555 11.96L12.1971 15.18L17.5402 8.37227C17.5498 8.36042 17.5601 8.34912 17.5709 8.33842H17.5694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckWhite);
export default __webpack_public_path__ + "static/media/icon_check_white.b35a1a8c5458ad5c4e01e2b80761662e.svg";
export { ForwardRef as ReactComponent };